import React, { useState } from 'react';
import { clsx } from 'clsx';
import { s as styles } from '../../../CopilotMessagePart.module-DU9_L9rT.mjs';
import { Icon, Spinner } from '@zapier/design-system';

const DebugPanel = ({ part }) => {
  const { toolInvocation } = part;
  return React.createElement(
    "div",
    { className: styles.toolInvocationDebug },
    React.createElement("h3", null, "Tool Name"),
    React.createElement("pre", null, toolInvocation.toolName),
    React.createElement("h3", null, "Args"),
    React.createElement("pre", null, JSON.stringify(toolInvocation.args, null, 2)),
    React.createElement("h3", null, "Result"),
    React.createElement("pre", null, JSON.stringify(toolInvocation.state === "result" ? toolInvocation.result : void 0, null, 2))
  );
};
DebugPanel.displayName = "DebugPanel";
const CopilotToolPart = ({ part, message, className, style, getToolCallDisplay, isDebug = false }) => {
  var _a, _b, _c, _d;
  const [isOpen, setIsOpen] = useState(false);
  const { toolInvocation } = part;
  const isUser = message.role === "user";
  const isLoading = toolInvocation.state !== "result";
  const displayOverride = (_a = getToolCallDisplay === null || getToolCallDisplay === void 0 ? void 0 : getToolCallDisplay(message, part)) !== null && _a !== void 0 ? _a : {};
  const icon = (_b = displayOverride.icon) !== null && _b !== void 0 ? _b : "actionBuild";
  const text = (_c = displayOverride.message) !== null && _c !== void 0 ? _c : isLoading ? `${toolInvocation.toolName} being called...` : `${toolInvocation.toolName} called.`;
  const isError = (_d = displayOverride.isError) !== null && _d !== void 0 ? _d : false;
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      "div",
      { className: clsx(isUser ? styles.userPart : styles.assistantPart, styles.toolInvocationPart, className, isDebug && styles.debug), style, onClick: () => isDebug && setIsOpen(!isOpen) },
      React.createElement(Icon, { name: icon, color: "UiPrimary" }),
      React.createElement("span", { className: styles.toolInvocationText }, text),
      isDebug && React.createElement(Icon, { name: "actionBug", color: "UiPrimary" }),
      isLoading ? React.createElement(Spinner, null) : isError ? React.createElement(Icon, { name: "formXCircleOutlined", color: "Red3" }) : React.createElement(Icon, { name: "formCheck", color: "Green3" })
    ),
    isOpen && React.createElement(DebugPanel, { part })
  );
};
CopilotToolPart.displayName = "CopilotToolPart";

export { CopilotToolPart, CopilotToolPart as default };
//# sourceMappingURL=CopilotToolPart.es.js.map
